import { Alert, Snackbar } from "@mui/material"
import { useCallback } from "react"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"

const alertStyle = { width: '100%' }

const Notification = ({ notification }) => {
  const dispatch = useDispatch()

  const handleClose = useCallback(() => {
    dispatch({ type: 'close-notification', id: notification.id })
  }, [notification, dispatch])

  return (
    <Snackbar open={true} autoHideDuration={notification.duration || 30000} onClose={handleClose}>
      <Alert onClose={handleClose} severity={notification.severity || 'info'} sx={alertStyle}>
        {notification.content}
      </Alert>
    </Snackbar>
  )
}

const AlertsBar = () => {
  const notifications = useSelector(state => state.notifications || [])

  return (
    <>
      {(notifications.length > 0) && <Notification notification={notifications[0]} />}
    </>
  )
}

export default AlertsBar